import { render, staticRenderFns } from "./ProjectBid.vue?vue&type=template&id=77bc3f4a&scoped=true"
import script from "./ProjectBid.vue?vue&type=script&lang=js"
export * from "./ProjectBid.vue?vue&type=script&lang=js"
import style0 from "./ProjectBid.vue?vue&type=style&index=0&id=77bc3f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc3f4a",
  null
  
)

export default component.exports